import { connect, injectReducer, injectSaga } from '@vfde-sails/core';
import addressValidationReducer from './reducer';
import { mountButton, updateButtonState } from '../../components/button';
import saga from './saga';
import { mapStateToProps } from './selector';
import * as mapDispatch from './action';
import { setElementVisibility } from '../../util/visibility';
import { mountCaptcha } from '../../components/captcha';
import { formValidation } from '@vfde-brix/ws10/validation';
import { AddressFormId, NameSpace } from '../../enum';
import { mountFormElement, updateSelectFormElement, updateTextFormElement } from '../../components/formElement';
import { CITY_VALIDATIONS, STREET_VALIDATIONS, HOUSENUMBER_VALIDATIONS } from './constants';
import { getUpdateFlags, isAddressError, isAppError } from './util/update';

export type State = ReturnType<typeof mapStateToProps>;
export type Actions = typeof mapDispatch;

function container (state: State, actions: Actions) {
    injectReducer(NameSpace.ADDRESS_VALIDATION, addressValidationReducer);
    injectSaga(NameSpace.ADDRESS_VALIDATION, saga);

    mountCaptcha();

    const cityOnChange = (city: string) => actions.setForm({ city });
    const streetOnChange = (street: string) => actions.setForm({ street });
    const numberOnChange = (housenumber: string) => actions.setForm({ housenumber });

    const city = mountFormElement(AddressFormId.CITY, cityOnChange, CITY_VALIDATIONS);
    const street = mountFormElement(AddressFormId.STREET, streetOnChange, STREET_VALIDATIONS);
    const housenumber = mountFormElement(AddressFormId.NUMBER, numberOnChange, HOUSENUMBER_VALIDATIONS);
    const select = mountFormElement(AddressFormId.SELECT, actions.setSelectedAddress);
    const submit = mountButton(AddressFormId.SUBMIT, actions.checkAddress);

    if (city && street && housenumber && submit) {
        formValidation({
            formFields: [ city, street, housenumber ],
            submitButton: submit,
        }, true, true);
    }

    return {
        getDerivedStateFromProps(newState: State, oldState: State) {
            const { form, addresses, selectedAddress, error } = newState;
            const update = getUpdateFlags(newState, oldState);

            const shouldShow = {
                serviceError: isAppError(error),
                addressError: isAddressError(error),
                addressSelect: addresses && addresses?.length > 1,
            };

            if (update.inputs) {
                const isAddressDeleted = Boolean(!selectedAddress && oldState.selectedAddress);

                updateTextFormElement(city, form.city, !isAddressDeleted);
                updateTextFormElement(street, form.street, !isAddressDeleted);
                updateTextFormElement(housenumber, form.housenumber, !isAddressDeleted);
                updateButtonState(submit, isAddressDeleted);
            }

            update.select && updateSelectFormElement(select, addresses);
            update.select && setElementVisibility(AddressFormId.NOT_UNIQUE_CONTAINER, shouldShow.addressSelect);
            update.addressError && setElementVisibility(AddressFormId.ADDRESS_ERROR, shouldShow.addressError);
            update.serviceError && setElementVisibility(AddressFormId.SERVICE_ERROR, shouldShow.serviceError);
        },
    };
}

export default connect(mapStateToProps, mapDispatch)(container);
